import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss']
})
export class TableSkeletonComponent {

  @Input() rows: number = 6;
  @Input() columns: number = 5;

  get rowArray(): number[] { return Array(this.rows); }
  get columnArray(): number[] { return Array(this.columns); }

}
